export const addCircles = (cornerstoneTools, viewPortRef, cx, cy, radius, lines) => {
  cornerstoneTools.clearToolState(viewPortRef.current, 'SquareGrid')
    cornerstoneTools.clearToolState(viewPortRef.current, 'CircleTool')
  
    cornerstoneTools.addToolState(viewPortRef.current, 'CircleTool',
      {
        "visible": true,
        "handles": {
          "start": {
            "x": cx,
            "y": cy,
          },
          "end": {
            "x": cx,
            "y": cy,
          }
        },
        radius: radius,
        lines: lines ? lines : [],
        "uuid": "c77922bd-0e12-4591-bab4-7a00d9d37a6b",
        "frame": ``,
      }
  
    )
  }

  

  export const addGridPoints = (cornerstoneTools, viewPortRef, points) => {
 
    cornerstoneTools.clearToolState(viewPortRef.current, 'CircleTool')
    cornerstoneTools.clearToolState(viewPortRef.current, 'SquareGrid')
      cornerstoneTools.addToolState(viewPortRef.current, 'SquareGrid', {
        visible: true,
        active: true,
        color: undefined,
        invalidated: true,
        lines: points//{'horizontal': [{'start': {'x': 0, 'y': 0}, 'end': {'x': 1024, 'y': 0}}, {'start': {'x': 0, 'y': 80}, 'end': {'x': 1024, 'y': 80}}, {'start': {'x': 0, 'y': 160}, 'end': {'x': 1024, 'y': 160}}, {'start': {'x': 0, 'y': 240}, 'end': {'x': 1024, 'y': 240}}, {'start': {'x': 0, 'y': 320}, 'end': {'x': 1024, 'y': 320}}, {'start': {'x': 0, 'y': 400}, 'end': {'x': 1024, 'y': 400}}, {'start': {'x': 0, 'y': 480}, 'end': {'x': 1024, 'y': 480}}, {'start': {'x': 0, 'y': 560}, 'end': {'x': 1024, 'y': 560}}, {'start': {'x': 0, 'y': 640}, 'end': {'x': 1024, 'y': 640}}, {'start': {'x': 0, 'y': 720}, 'end': {'x': 1024, 'y': 720}}, {'start': {'x': 0, 'y': 800}, 'end': {'x': 1024, 'y': 800}}, {'start': {'x': 0, 'y': 880}, 'end': {'x': 1024, 'y': 880}}, {'start': {'x': 0, 'y': 960}, 'end': {'x': 1024, 'y': 960}}], 'vertical': [{'start': {'x': 0, 'y': 0}, 'end': {'x': 0, 'y': 1024}}, {'start': {'x': 80, 'y': 0}, 'end': {'x': 80, 'y': 1024}}, {'start': {'x': 160, 'y': 0}, 'end': {'x': 160, 'y': 1024}}, {'start': {'x': 240, 'y': 0}, 'end': {'x': 240, 'y': 1024}}, {'start': {'x': 320, 'y': 0}, 'end': {'x': 320, 'y': 1024}}, {'start': {'x': 400, 'y': 0}, 'end': {'x': 400, 'y': 1024}}, {'start': {'x': 480, 'y': 0}, 'end': {'x': 480, 'y': 1024}}, {'start': {'x': 560, 'y': 0}, 'end': {'x': 560, 'y': 1024}}, {'start': {'x': 640, 'y': 0}, 'end': {'x': 640, 'y': 1024}}, {'start': {'x': 720, 'y': 0}, 'end': {'x': 720, 'y': 1024}}, {'start': {'x': 800, 'y': 0}, 'end': {'x': 800, 'y': 1024}}, {'start': {'x': 880, 'y': 0}, 'end': {'x': 880, 'y': 1024}}, {'start': {'x': 960, 'y': 0}, 'end': {'x': 960, 'y': 1024}}]}
        ,handles: {
          start: {
            x:0,
            y:0,
            highlight: true,
            active: false,
          },
          end: {
            x:550,
            y:100,
            highlight: true,
            active: true,
          },
        }
      })
      
  }

  